import { createApi } from '@shared/redux/createApi';
import { serialize } from '../../../shared/lib/serialize';
import { format } from '../../../shared/lib/format';

const tags = {
  getLiquidity: 'getLiquidity',
  getLiquidityIncoming: 'getLiquidityIncoming',
  getLiquidityOutgoing: 'getLiquidityOutgoing',
  getLiquidityDetails: 'getLiquidityDetails',
  getUserInfo: 'getUserInfo',
};
export const liquidityApi = createApi({
  reducerPath: 'liquidityApi',
  tagTypes: [tags.getLiquidity, tags.getUserInfo],

  endpoints: (builder) => ({
    getLiquidity: builder.query({
      query: ({asset, start, end}) => {
        let params = {
          asset: asset,
        };

        if (start) {
          params = {
            ...params,
            start: `${start.getDate()}/${format.addZeroBefore(start.getMonth() + 1)}/${start.getFullYear()}`,
          };
        }

        if (end) {
          params = {
            ...params,
            end: `${end.getDate()}/${format.addZeroBefore(end.getMonth() + 1)}/${end.getFullYear()}`,
          };
        }

        return ({
          method: 'get', url: `/liquidity/liquidity?${serialize(params)}`,
        });
      },
      providesTags: [tags.getLiquidity],
    }),
    getLiquidityDetails: builder.query({
      query: ({asset}) => ({
        method: 'get', url: `/liquidity/${asset}`,
      }),
      providesTags: [tags.getLiquidityDetails],
    }),
    getLiquidityIncoming: builder.query({
      query: ({asset, page, limit, start, end}) => {
        let params = {
          page_number: page,
          page_size: limit,
        };

        if (start) {
          params.start = `${start.getDate()}/${format.addZeroBefore(start.getMonth() + 1)}/${start.getFullYear()}`;
        }

        if (end) {
          params.end = `${end.getDate()}/${format.addZeroBefore(end.getMonth() + 1)}/${end.getFullYear()}`;
        }

        return {
          method: 'get', url: `liquidity/${asset}/incoming?${serialize(params)}`,
        };
      },
      providesTags: [tags.getLiquidityIncoming],
      transformResponse: (data) => {
        return {
          list: data.list,
          count: data.page_amount,
        };
      },
    }),
    getLiquidityOutgoing: builder.query({
      query: ({asset, page, limit, start, end}) => {
        let params = {
          page_number: page,
          page_size: limit,
        };

        if (start) {
          params.start = `${start.getDate()}/${format.addZeroBefore(start.getMonth() + 1)}/${start.getFullYear()}`;
        }

        if (end) {
          params.end = `${end.getDate()}/${format.addZeroBefore(end.getMonth() + 1)}/${end.getFullYear()}`;
        }

        return {
          method: 'get', url: `liquidity/${asset}/outgoing?${serialize(params)}`,
        };
      },
      providesTags: [tags.getLiquidityOutgoing],
      transformResponse: (data) => {
        return {
          list: data.list,
          count: data.page_amount,
        };
      },
    }),
    getUserInfo: builder.query({
      query: () => ({
        method: 'get',
        url: '/admin/users-count',
      }),
      providesTags: [tags.getUserInfo],
    }),
    depositLiquidity: builder.mutation({
      query: (data) => ({
        method: 'post',
        url: '/liquidity/add',
        body: data
      }),
      invalidatesTags: [tags.getLiquidity, tags.getLiquidityIncoming, tags.getLiquidityOutgoing, tags.getLiquidityDetails],
    }),
    getLiquidityItem: builder.query({
      query: ({ asset, sk }) => ({
        method: 'get',
        url: `/liquidity/liquidity-item?${serialize({ asset, sk })}`,
      }),
    }),
    withdrawLiquidity: builder.mutation({
      query: (data) => ({
        method: 'post',
        url: '/liquidity/subtract',
        body: data
      }),
      invalidatesTags: [tags.getLiquidity, tags.getLiquidityIncoming, tags.getLiquidityOutgoing, tags.getLiquidityDetails],
    }),
  }),
});

export const { 
  useGetLiquidityQuery, 
  useGetLiquidityDetailsQuery, 
  useGetLiquidityIncomingQuery, 
  useGetLiquidityOutgoingQuery,
  useGetUserInfoQuery,
  useDepositLiquidityMutation,
  useWithdrawLiquidityMutation,
  useGetLiquidityItemQuery
} = liquidityApi;